<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.25 3.48796C10.3075 3.29546 8.35333 3.19629 6.405 3.19629C5.25 3.19629 4.095
      3.25462 2.94 3.37129L1.75 3.48796"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.95703 2.899L5.08536 2.13484C5.1787 1.58067 5.2487 1.1665 6.23453
      1.1665H7.76286C8.7487 1.1665 8.82453 1.604 8.91203 2.14067L9.04036 2.899"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9956 5.33154L10.6164 11.2057C10.5522 12.1215 10.4997 12.8332 8.87224
      12.8332H5.12724C3.49974 12.8332 3.44724 12.1215 3.38307 11.2057L3.00391 5.33154"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.02734 9.625H7.96984"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.54297 7.2915H8.45964"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DeleteIcon',
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
  },
};
</script>
